import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MdbModalRef, MdbModalService } from "mdb-angular-ui-kit/modal";
import { Router } from "@angular/router";
import { V } from "@angular/cdk/keycodes";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import Swal from "sweetalert2";
import { EditorModule, TINYMCE_SCRIPT_SRC } from "@tinymce/tinymce-angular";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-energyidea",
  templateUrl: "./energyidea.component.html",
  styleUrls: ["./energyidea.component.css"],
})
export class EnergyideaComponent implements OnInit {
  idea_id: any;
  idea_name: any;
  fake = "6";
  form: any;
  q1: any;
  q2: any;
  q3: any;
  q4: any;
  q5: any;
  q6: any;
  q7: any;
  q8: any;
  q9: any;
  q10: any;
  sa1: any;
  sa2: any;
  sa3: any;
  sa4: any;
  sa5: any;
  sa6: any;
  sa7: any;
  sa8: any;
  sa9: any;
  sa10: any;
  displayStyles = "none";
  category = [
    { value: "Net Zero Missions", viewValue: "Net Zero Missions" },
    { value: "Advanced Energy Storage", viewValue: "Advanced Energy Storage" },
    {
      value: "Digitalization in oil & gas sector",
      viewValue: "Digitalization in oil & gas sector",
    },
    {
      value: "Polymer & Petrochemicals",
      viewValue: "Polymer & Petrochemicals",
    },
    {
      value: "Water Management in oil & gas sector",
      viewValue: "Water Management in oil & gas sector",
    },
    {
      value: "Innovative products / processes/ services  in oil & gas sector",
      viewValue:
        "Innovative products / processes/ services  in oil & gas sector",
    },
    { value: "Circular Economy", viewValue: "Circular Economy" },
    { value: "Biotechnology", viewValue: "Biotechnology" },
  ];
  constructor(
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    private router: Router
  ) {}
  // safeSrc1 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/c9F5kMUfFKk");
  // safeSrc2 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://youtu.be/HTJKD6PzvVE");
  // safeSrc3 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=wWpEiSKeDDo&t=2s");
  // safeSrc4 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=C91utiNU0cI");
  // safeSrc5 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=Y2-5aPewZCA");
  // safeSrc6 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/watch?v=rlPVu0EzGAY");
  // safeSrc7 =  this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/c9F5kMUfFKk");
  lit: any;
  list = [];
  link: any;
  listing: any;
  ids: any;
  auth: any;
  track: any;
  public myForm = new FormGroup({
    ques1: new FormControl("", Validators.required),
    ques2: new FormControl("", Validators.required),
    ques3: new FormControl("", Validators.required),
    ques4: new FormControl("", Validators.required),
    ques5: new FormControl("", Validators.required),
    ques6: new FormControl("", Validators.required),
    ques7: new FormControl("", Validators.required),
    ques8: new FormControl("", Validators.required),
    ques9: new FormControl("", Validators.required),
    track: new FormControl("", Validators.required),
  });

  ngOnInit(): void {
    this.ids = localStorage.getItem("formFilled");
    this.auth = localStorage.getItem("authToken");
    this.track = localStorage.getItem("track");
    // console.log(this.ids)
    // console.log(this.auth)
    if (this.auth == null) {
      //isloggedin
      Swal.fire("Login first to access dashboard");
      this.router.navigate(["/login"]);
    } else {
      if (this.ids == "true" && this.track == "Energy") {
        //isfilled
        this.router.navigate(["/energyidea"]);
      }
      // else{
      //   this.router.navigate(['/db']);
      // }
    }

    if (!localStorage.getItem("foo")) {
      localStorage.setItem("foo", "no reload");
      location.reload();
    } else {
      localStorage.removeItem("foo");
    }
    this.displayStyles = "block";

    this.idea_id = localStorage.getItem("tempid");
    this.idea_name = localStorage.getItem("prelname");
    var body: any = new FormData();
    body.append("id", this.idea_id);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    console.log(headers);
    this.http
      .post<any>(environment.API_URL + "getQuessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        this.lit = data;
        this.list = this.lit.all_ques;
        this.listing = this.list[0];
        console.log(this.listing.id);
        localStorage.setItem("listing", this.listing.id);
        localStorage.setItem("ques1", this.listing.ques1);
        localStorage.setItem("ques2", this.listing.ques2);
        localStorage.setItem("ques3", this.listing.ques3);
        localStorage.setItem("ques4", this.listing.ques4);
        localStorage.setItem("ques5", this.listing.ques5);
        localStorage.setItem("ques6", this.listing.ques6);
        localStorage.setItem("ques7", this.listing.ques7);
        localStorage.setItem("ques8", this.listing.ques8);
        localStorage.setItem("ques9", this.listing.ques9);
        localStorage.setItem("track", this.listing.track);
        this.form = {
          ques1: this.listing.ques1,
          ques2: this.listing.ques2,
          ques3: this.listing.ques3,
          ques4: this.listing.ques4,
          ques5: this.listing.ques5,
          ques6: this.listing.ques6,
          ques7: this.listing.ques7,
          ques8: this.listing.ques8,
          ques9: this.listing.ques9,
          track: this.listing.track,
        };
        // ques1: new FormControl("this.listing.ques1", Validators.required);
        this.displayStyles = "none";
        // ques2: new FormControl("this.listing.ques2", Validators.required);
        // ques3: new FormControl("this.listing.ques3", Validators.required);
        // ques4: new FormControl("this.listing.ques4", Validators.required);
        // ques5: new FormControl("this.listing.ques5", Validators.required);
        // ques6: new FormControl("this.listing.ques6", Validators.required);
        // ques7: new FormControl("this.listing.ques7", Validators.required);
      });
    // console.log(this.listing.id);
    // console.log(localStorage.getItem('listing'))
    this.q1 = localStorage.getItem("ques1");
    console.log(this.q1);
    this.q2 = localStorage.getItem("ques2");
    this.q3 = localStorage.getItem("ques3");
    this.q4 = localStorage.getItem("ques4");
    this.q5 = localStorage.getItem("ques5");
    this.q6 = localStorage.getItem("ques6");
    this.q7 = localStorage.getItem("ques7");
    this.q8 = localStorage.getItem("ques8");
    this.q9 = localStorage.getItem("ques9");
    this.q10 = localStorage.getItem("track");
    this.form = {
      ques1: this.listing.ques1,
      ques2: this.listing.ques2,
      ques3: this.listing.ques3,
      ques4: this.listing.ques4,
      ques5: this.listing.ques5,
      ques6: this.listing.ques6,
      ques7: this.listing.ques7,
      ques8: this.listing.ques8,
      ques9: this.listing.ques9,
      track: this.listing.track,
    };

    this.displayStyles = "none";
  }

  onques1() {
    this.displayStyles = "block";

    // this.q1 = this.myForm.value.ques1
    // localStorage.setItem("ques1", this.q1)
    // console.log(localStorage.getItem("ques1"))
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques1", this.myForm.value.ques1);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques1", this.listing.ques1);
            ques1: new FormControl("ques1", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques2() {
    this.displayStyles = "block";

    // this.q2 = this.myForm.value.ques2
    // localStorage.setItem("ques2", this.q2)
    // console.log(localStorage.getItem("ques2"))
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques2", this.myForm.value.ques2);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques2", this.listing.ques2);
            ques2: new FormControl("ques2", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques3() {
    this.displayStyles = "block";

    // this.q3 = this.myForm.value.ques3
    // localStorage.setItem("ques3", this.q3)
    // console.log(localStorage.getItem("ques3"))
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques3", this.myForm.value.ques3);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques3", this.listing.ques3);
            ques3: new FormControl("ques3", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques4() {
    // this.q4 = this.myForm.value.ques4
    // localStorage.setItem("ques4", this.q4)
    // console.log(localStorage.getItem("ques4"))
    this.displayStyles = "block";

    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques4", this.myForm.value.ques4);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques4", this.listing.ques4);
            ques4: new FormControl("ques4", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques5() {
    // this.q5 = this.myForm.value.ques5
    // localStorage.setItem("ques5", this.q5)
    // console.log(localStorage.getItem("ques5"))
    this.displayStyles = "block";

    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques5", this.myForm.value.ques5);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques5", this.listing.ques5);
            ques5: new FormControl("ques5", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques6() {
    this.displayStyles = "block";

    // this.q6 = this.myForm.value.ques6
    // localStorage.setItem("ques6", this.q6)
    // console.log(localStorage.getItem("ques6"))
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques6", this.myForm.value.ques6);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques6", this.listing.ques6);
            ques6: new FormControl("ques6", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques7() {
    // this.q7 = this.myForm.value.ques7
    // localStorage.setItem("ques7", this.q7)
    // console.log(localStorage.getItem("ques7"))
    this.displayStyles = "block";

    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques7", this.myForm.value.ques7);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques7", this.listing.ques7);
            ques7: new FormControl("ques7", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques8() {
    this.displayStyles = "block";

    // this.q7 = this.myForm.value.ques7
    // localStorage.setItem("ques7", this.q7)
    // console.log(localStorage.getItem("ques7"))
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques8", this.myForm.value.ques8);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques8", this.listing.ques8);
            ques7: new FormControl("ques8", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onques9() {
    this.displayStyles = "block";

    // this.q7 = this.myForm.value.ques7
    // localStorage.setItem("ques7", this.q7)
    // console.log(localStorage.getItem("ques7"))
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques9", this.myForm.value.ques9);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        var body: any = new FormData();
        body.append("id", this.idea_id);
        const headers = {
          Authorization: "Token " + localStorage.getItem("authToken"),
        };
        this.http
          .post<any>(environment.API_URL + "getQuessionare/", body, {
            headers,
          })
          .subscribe((data) => {
            this.lit = data;
            this.list = this.lit.all_ques;
            this.listing = this.list[0];
            console.log(this.listing.id);
            localStorage.setItem("ques9", this.listing.ques9);
            ques7: new FormControl("ques9", Validators.required);
            this.displayStyles = "none";

            Swal.fire({
              position: "center",
              // icon: 'success',
              title: "Your response has been saved",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      });
  }
  onsubmit() {
    this.displayStyles = "block";

    // console.log(this.myForm.value.ques1)
    // console.log(this.myForm.value.ques2)
    // console.log(this.myForm.value.ques3)
    // console.log(this.myForm.value.ques4)
    // console.log(this.myForm.value.ques5)
    // console.log(this.myForm.value.ques6)
    // console.log(this.myForm.value.ques7)
    // console.log(this.myForm.value.ques8)
    // console.log(this.myForm.value.ques9)
    // console.log(this.myForm.value.track)

    console.log(this.idea_id);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    var body: any = new FormData();
    body.append("idea_id", this.idea_id);
    body.append("ques1", this.myForm.value.ques1);
    body.append("ques2", this.myForm.value.ques2);
    body.append("ques3", this.myForm.value.ques3);
    body.append("ques4", this.myForm.value.ques4);
    body.append("ques5", this.myForm.value.ques5);
    body.append("ques6", this.myForm.value.ques6);
    body.append("ques7", this.myForm.value.ques7);
    body.append("ques8", this.myForm.value.ques8);
    body.append("ques9", this.myForm.value.ques9);
    body.append("track", this.myForm.value.track);
    this.http
      .post<any>(environment.API_URL + "quessionare/", body, {
        headers,
      })
      .subscribe((data) => {
        console.log("headers");
        this.displayStyles = "block";
        Swal.fire("Submitted Successfully");
        this.router.navigateByUrl("/db");
      });
  }
  displayStyle1 = "none";
  openPopup1() {
    this.displayStyle1 = "block";
  }
  closePopup1() {
    this.displayStyle1 = "none";
  }

  displayStyle2 = "none";
  openPopup2() {
    this.displayStyle2 = "block";
  }
  closePopup2() {
    this.displayStyle2 = "none";
  }

  displayStyle3 = "none";
  openPopup3() {
    this.displayStyle3 = "block";
  }
  closePopup3() {
    this.displayStyle3 = "none";
  }

  displayStyle4 = "none";
  openPopup4() {
    this.displayStyle4 = "block";
  }
  closePopup4() {
    this.displayStyle4 = "none";
  }

  displayStyle5 = "none";
  openPopup5() {
    this.displayStyle5 = "block";
  }
  closePopup5() {
    this.displayStyle5 = "none";
  }

  displayStyle6 = "none";
  openPopup6() {
    this.displayStyle6 = "block";
  }
  closePopup6() {
    this.displayStyle6 = "none";
  }

  displayStyle7 = "none";
  openPopup7() {
    this.displayStyle7 = "block";
  }
  closePopup7() {
    this.displayStyle7 = "none";
  }
  displayStyle8 = "none";
  openPopup8() {
    this.displayStyle8 = "block";
  }
  closePopup8() {
    this.displayStyle8 = "none";
  }
  displayStyle9 = "none";
  openPopup9() {
    this.displayStyle9 = "block";
  }
  closePopup9() {
    this.displayStyle9 = "none";
  }
}
